import React from 'react'
import { Component } from 'reflux'
import { StockLocationActions, StockLocationStore, STATUS } from 'Stores/stockLocationStore'
import { Button, Form, Input, Row, Col, Label } from 'reactstrap'
import _ from 'lodash'
import CollapsibleCard from 'Components/collapsibleCard'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default class StockLocationForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [StockLocationStore]
    this.storeKeys = ['status', 'stockLocationDetails']
  }

  resetStockLocation = () => {
    if (_.get(this.props, 'match.params.StockLocationID')) {
      StockLocationActions.getStockLocationDetails(this.props.match.params.StockLocationID)
    } else {
      StockLocationActions.createEmptyStockLocation()
    }
  }

  render() {
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/stockLocations' />
    }
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <>
        <CollapsibleCard startOpen header={<strong>{_.get(this.props, 'match.params.StockLocationID') ? 'Detaljer' : 'Opret'}</strong>}>
          <Form>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='name'>Navn</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.stockLocationDetails.name}
                  name='name'
                  id='name'
                  onChange={StockLocationActions.updateStockLocationField}
                />
              </Col>
            </Row>

            <Button
              onClick={StockLocationActions.saveStockLocation}
              disabled={this.state.status === STATUS.IS_SAVING || !this.state.stockLocationDetails.name.length}
            >
              {this.state.status === STATUS.IS_SAVING ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
            </Button>
            <Button color='danger' onClick={this.resetStockLocation} className='ml-2'>
              Nulstil
            </Button>
          </Form>
        </CollapsibleCard>
      </>
    )
  }
}
